export const availableLangs = ['en'];
export const scopeLoader = (importer) => {
  return availableLangs.reduce((acc, lang) => {
    acc[lang] = () => importer(lang);
    return acc;
  }, {});
};
